export default "__VITE_ASSET__CFFyU3dv__"